import React from "react";
import css from "./about.module.css";

export const AboutUs = ({ isHomePage }) => {
  return (
    <section className={`${css.about} ${isHomePage ? css.noPadding : ""}`}>
      <div className={css.blockone}>
        <h1 className={css.title}>Мастерская интерьерных решений «Геометрия стиля»</h1>
        <div className={css.text}>
          <p className={css.paragraph}>
            Добро пожаловать в мастерскую, где профессионализм и страсть к
            совершенству создают идеальные интерьеры! <strong>Мы специализируемся на
            изготовлении столешниц, подоконников, барных стоек и других
            элементов из кварцевого агломерата,</strong> превращая ваши идеи в
            долговечные и стильные решения.
          </p>
          <h2 className={css.subtitle}>
            {" "}
            Почему Геометрия стиля — ваш лучший выбор?
          </h2>
          <p className={css.paragraph}>
            В отличие от конкурентов, где директора и менеджеры часто не
            разбираются ни в материалах, ни в процессах, в нашей мастерской
            каждый сотрудник — эксперт в области кварцевого агломерата. Наша
            команда состоит из профессионалов, которые досконально знают все
            этапы — от проектирования до монтажа.{" "}
          </p>
          <ul className={css.list}>
            Это гарантирует вам:
            <li className={css.item}>
              Изготовление в оговоренный срок без задержек и прочих проблем.
            </li>
            <li className={css.item}>
              Безупречное качество: Мы исключаем ошибки на этапе проектирования,
              обеспечивая точность и функциональность каждого изделия.
            </li>
            <li className={css.item}>
              Надежное изготовление: Наши мастера используют передовые
              технологии и премиальный кварцевый агломерат, устойчивый к
              царапинам, пятнам и высоким температурам.
            </li>
            <li className={css.item}>
              Профессиональный монтаж: Грамотная установка без сюрпризов — ваши
              столешницы и подоконники будут идеально вписаны в пространство.{" "}
            </li>
          </ul>
        </div>
        <p className={css.paragraph}>
          Мы избавляем вас от проблем, связанных с некачественным дизайном,
          ошибками в производстве или непрофессиональной установкой, которые
          часто встречаются у конкурентов. С нашей Мастерской вы
          получаете уверенность в результате и наслаждаетесь процессом создания
          интерьера вашей мечты.
        </p>
        <h3 className={css.title}>Наши услуги:</h3>
        <ul className={css.list}>
          <li className={css.item}>
            Стильные и прочные столешницы для кухонь и ванных комнат.
          </li>
          <li className={css.item}>
            Элегантные подоконники, идеально дополняющие интерьер.
          </li>
          <li className={css.item}>
            {" "}
            Барные стойки, ресепшены и другие элементы для дома и бизнеса.{" "}
          </li>
          <li className={css.item}>
            {" "}
            Консультации по подбору материалов и дизайну.{" "}
          </li>
          <li className={css.item}>
            Профессиональная установка с гарантией качества.{" "}
          </li>
        </ul>
      </div>
    </section>
  );
};
